import React, { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { api, errorMessage } from "../lib/api";

export default function AdminPickupEmail() {
  const [body, setBody] = useState("");
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  const send = async (e) => {
    e.preventDefault();
    if (!body.trim()) return;
    if (!confirm("Send this pickup reminder to all active pickup customers this week?")) return;
    setSending(true);
    setResult(null);
    try {
      const { data } = await api.post("/admin/email-pickup-customers", { body });
      toast.success(data.message);
      setResult(data);
      setBody("");
    } catch (e) { toast.error(errorMessage(e)); }
    finally { setSending(false); }
  };

  return (
    <div data-testid="admin-pickup-email">
      <h1 className="font-display font-extrabold text-3xl md:text-4xl">Pickup Customers — Mass Email</h1>
      <p className="text-gray-500 mt-1 text-sm mb-6">
        Sends a digest with the message + roster of every customer who has an active pickup order (Confirmed / Preparing / Ready) from the last 7 days.
      </p>

      <form onSubmit={send} className="bg-white border border-gray-100 rounded-2xl p-5 max-w-2xl">
        <label className="block">
          <span className="text-xs uppercase tracking-widest font-bold text-[#4B5563]">Subject</span>
          <input className="input-base mt-1 bg-gray-50" value="Sugary Sweet — Pickup Reminder" disabled />
          <p className="text-[11px] text-gray-400 mt-1">Subject is template-locked for consistency.</p>
        </label>
        <label className="block mt-4">
          <span className="text-xs uppercase tracking-widest font-bold text-[#4B5563]">Message</span>
          <textarea
            className="input-base mt-1 min-h-[180px]"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            placeholder="Hey! Just a reminder that your pickup is ready Saturday between 10am and 1pm at our usual spot. Bring your order number. See you soon!"
            required
            data-testid="pickup-email-body"
          />
        </label>
        <button type="submit" disabled={sending} className="btn-pink mt-4 inline-flex items-center" data-testid="pickup-email-send-btn">
          <Send className="w-4 h-4 mr-2" /> {sending ? "SENDING..." : "SEND TO ACTIVE PICKUP CUSTOMERS"}
        </button>

        {result && (
          <div className="mt-4 p-4 rounded-2xl bg-emerald-50 border border-emerald-200 text-emerald-800 text-sm" data-testid="pickup-email-result">
            {result.message}
          </div>
        )}
      </form>
    </div>
  );
}
